import { gql } from "@apollo/client";

export const InstalledBaseNodeEventContext = gql`
    query InstalledBaseNodeEventContext ($id: ID!) {
        installedBaseNode (id: $id) {
            id
            title
            availableInstalledBaseEvents
            nodeType {
                id
                key
            }
            assetLocation {
                id
                isInstalled
                # Hours per day for the event wizard's date → runningTime recompute
                # (see eventRunningTimeSync.ts).
                averageRuntimePerDay
                asset {
                    id
                    # Category via the product, NOT Asset.productCategory: selecting urn on
                    # the asset's direct category crashes the catalog subgraph resolver.
                    product {
                        id
                        productCategory {
                            id
                            urn
                        }
                    }
                }
            }
            parentNode {
                id
            }
            # pathNodes[0] = client root: scopes the relocation picker to the own client.
            pathNodes {
                id
            }
            access {
                id
                write
            }
        }
    }
`;
